export const formatUrlName = (name: string): string => {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/\s+/g, '-')     // Replace spaces with hyphens
    .replace(/[&?=#%+\/\\:@;,\[\]{}|"'!$()*~]/g, '') // Remove problematic URL characters
    .replace(/-+/g, '-')     // Replace multiple hyphens with single hyphen
    .replace(/^-|-$/g, '');  // Remove leading and trailing hyphens
};

export const generateUrlName = (name: string, id: string | number): string => {
  return `${formatUrlName(name)}-${id}`;
};

export const generateUrl = (name: string, id: string | number): string => {
  return `/${generateUrlName(name,id)}`;
};

export const generateDetailUrl = (
  stationName: string,
  stationId: string | number,
  section?: string,
  itemName?: string,
  itemId?: string | number
): string => {
  const urlName = formatUrlName(itemName||'');
  const stationPart = generateUrl(stationName, stationId);
  const sectionPart = `/${section}`;
  const itemPart = itemId ? `/${urlName}-${itemId}` : ``;
  return `${stationPart}${sectionPart}${itemPart}`;
};

export const parseUrlName = (urlName: string): string => {
  if (!urlName) return '';
  return urlName
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}; 

export const getIdFromUrlName = (urlName: string): string => {
  if (!urlName) return '';
  return urlName.split('-').pop()+'';
};

export const getBaseUrl = (): string => {
  return import.meta.env.VITE_SITE_URL || window.location.origin;
};

export const getFullUrl = (url: string): string => {
  if (url.startsWith('/')) {
    return `${getBaseUrl()}${url}`;
  }
  return url;
};